import React, { useState, useEffect } from 'react';
import { examsAPI, Exam } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import { ClipboardDocumentListIcon, ClockIcon, UsersIcon } from '@heroicons/react/24/outline';

const Exams: React.FC = () => {
  const [exams, setExams] = useState<Exam[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadExams();
  }, []);

  const loadExams = async () => {
    try {
      const response = await examsAPI.getExams({ is_published: true });
      if (response.success && response.data) {
        setExams(response.data.items);
      }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const startExam = async (examId: number) => {
    try {
      const response = await examsAPI.startExam(examId);
      if (response.success && response.data) {
        // 这里可以跳转到考试页面
        console.log('开始考试:', response.data);
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  if (loading) {
    return <LoadingSpinner className="py-12" />;
  }

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          <ClipboardDocumentListIcon className="h-6 w-6 inline mr-2" />
          考试列表
        </h2>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md mb-6">
            {error}
          </div>
        )}

        <div className="space-y-4">
          {exams.length === 0 ? (
            <p className="text-gray-500 text-center py-8">暂无可用考试</p>
          ) : (
            exams.map((exam) => (
              <div key={exam.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{exam.title}</h3>
                    <p className="text-gray-600 mt-1">{exam.description || '无描述'}</p>
                  </div>
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                    已发布
                  </span>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 text-sm text-gray-600">
                  <div className="flex items-center">
                    <ClipboardDocumentListIcon className="h-4 w-4 mr-1" />
                    <span>题目数量: {exam.total_questions}</span>
                  </div>
                  <div className="flex items-center">
                    <ClockIcon className="h-4 w-4 mr-1" />
                    <span>时间限制: {exam.time_limit ? `${exam.time_limit}分钟` : '无限制'}</span>
                  </div>
                  <div className="flex items-center">
                    <UsersIcon className="h-4 w-4 mr-1" />
                    <span>最大尝试: {exam.max_attempts}</span>
                  </div>
                  <div>
                    <span>创建时间: {new Date(exam.created_at).toLocaleDateString()}</span>
                  </div>
                </div>

                <button
                  onClick={() => startExam(exam.id)}
                  className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
                >
                  开始考试
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Exams;
